<script>
export default {
  props: {
    data: {
      default: null,
      type: Object,
    },
  },
}
</script>

<template>
  <div>
    <div class="mainRow mb-4">
      <div class="imageClass">
        <img class="imageSize" :src="data.image" />
      </div>
      <div class="infoClass">
        <b-row class="justify-content-between align-items-center mb-2">
          <b-col cols="5" class="title">{{ data.title }}</b-col>
          <b-col v-if="data.seller" cols="7" class="d-flex align-items-center justify-content-end">
            <img v-if="data.seller.image" class="userImage me-2" :src="data.seller.image" alt="" />
            <div v-if="data.seller.fullName" class="userName me-4">{{ data.seller.fullName }}</div>
            <div v-if="data.seller.phone" class="userMobile">{{ data.seller.phone }}</div>
          </b-col>
        </b-row>
        <div v-for="property in data.properties" :key="property.id" class="detailsRow">
          <div class="titleDetails">{{ property.key }} :</div>
          <div>{{ property.value }}</div>
        </div>
        <div class="detailsRow">
          <div class="titleDetails">قیمت کل :</div>
          <div class="d-flex">
            <div class="price">
              {{ Commafy(data.price) }}
            </div>
            <div style="font-size: 13px; margin-right: 5px; display: flex; align-items: end; color: #556ee6">تومان</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mainRow {
  display: flex;
}
.infoClass {
  padding-right: 12px;
  width: 100%;
}

.imageSize {
  background: #c4c4c4;
  width: 150px;
  height: 150px;
  margin: 0px 3px;
}
.userImage {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: 0px 3px;
}
.userName {
  font-size: 14px;
  line-height: 26px;
  text-align: right;
  color: #4a4a4a;
  margin: 0px 3px;
}
.userMobile {
  font-size: 12px;
  line-height: 23px;
  text-align: right;
  color: #4a4a4a;
}
.title {
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 30px;
  text-align: right;
  color: #4a4a4a;
}
.price {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #556ee6;
}
.titleDetails {
  font-size: 15px;
  margin-left: 10px;
  color: #c4c4c4;
}
.detailsRow {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 14px;
}
@media only screen and (max-width: 1500px) {
  .imageSize {
    width: 170px;
    height: 170px;
  }

  .infoClass {
    padding-right: 5px;
  }
}
</style>
